import type { WellnessInsightInput, WellnessInsightMetric, WellnessMetricId } from './types';

// Documented metric order also provides a deterministic tie-break across pillars.
const WELLNESS_METRIC_ORDER: readonly WellnessMetricId[] = [
  'spending',
  'cashFlow',
  'creditUtilization',
  'netWorth',
  'debt',
  'creditScore',
  'cushion',
  'liquidity',
  'flexibility',
];

// Below Good, by each source's own tier: the API's `tier.level`, or the client's chip tier string.
const BELOW_GOOD_TIERS: ReadonlySet<unknown> = new Set(['FAIR', 'NEEDS_WORK', 'Fair', 'Needs work']);

const isBelowGood = ({ tier }: Record<string, unknown>): boolean =>
  BELOW_GOOD_TIERS.has(typeof tier === 'object' && tier !== null && 'level' in tier ? tier.level : tier);

const hasValidScore = (
  metric: WellnessInsightInput['metrics'][WellnessMetricId],
): metric is WellnessInsightMetric['metric'] => typeof metric?.score === 'number' && Number.isFinite(metric.score);

export const getLowestScoringMetrics = (response: WellnessInsightInput): WellnessInsightMetric[] => {
  const eligibleMetrics: WellnessInsightMetric[] = [];

  for (const metricId of WELLNESS_METRIC_ORDER) {
    const metric = response.metrics[metricId];
    if (hasValidScore(metric) && isBelowGood(metric)) {
      eligibleMetrics.push({ metricId, metric });
    }
  }

  // Array.sort is stable: equal scores retain the documented order above.
  return eligibleMetrics.sort((left, right) => left.metric.score - right.metric.score);
};
